module.exports = __webpack_public_path__ + "static/media/intro-en-fr.602314ea.vtt";